import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import DecorBackground from '@/components/marketing/DecorBackground';

export default function PageHeader({ eyebrow, title, subtitle, breadcrumbs = [], children }) {
  return (
    <section className="relative overflow-hidden bg-[#050B17] text-white isolate">
      <DecorBackground variant="header" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        {breadcrumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-6" data-testid="page-breadcrumbs">
            <ol className="flex items-center gap-1.5 text-[12px] text-slate-400">
              <li><Link to="/" className="hover:text-[#22D3EE] transition-colors">Home</Link></li>
              {breadcrumbs.map((b, i) => (
                <React.Fragment key={i}>
                  <li><ChevronRight className="h-3 w-3" /></li>
                  <li>
                    {b.to ? (
                      <Link to={b.to} className="hover:text-[#22D3EE] transition-colors">{b.label}</Link>
                    ) : (
                      <span className="text-slate-300">{b.label}</span>
                    )}
                  </li>
                </React.Fragment>
              ))}
            </ol>
          </nav>
        )}
        {eyebrow && (
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.04] border border-white/10 text-[12px] font-medium text-[#22D3EE] backdrop-blur-md">
            <span className="h-1.5 w-1.5 rounded-full bg-[#22D3EE]" /> {eyebrow}
          </span>
        )}
        <h1 className="font-display-tight mt-5 text-[40px] sm:text-[52px] lg:text-[64px] font-bold tracking-[-0.035em] leading-[1.05] text-white max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-[17px] sm:text-[19px] text-slate-300/90 max-w-2xl leading-[1.65]">{subtitle}</p>
        )}
        {children && <div className="mt-7">{children}</div>}
      </div>
    </section>
  );
}
